import styled from "styled-components";

export const FilterBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const FilterBarLeftContent = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex: 1;
`;

export const FilterBarRightContent = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;
